var map = {
	"./cs.json": [
		80769,
		80769
	],
	"./de.json": [
		8580,
		8580
	],
	"./en.json": [
		52320,
		52320
	],
	"./es.json": [
		53335,
		53335
	],
	"./fr.json": [
		77987,
		77987
	],
	"./it.json": [
		7998,
		7998
	],
	"./ja.json": [
		42334,
		42334
	],
	"./ko.json": [
		40629,
		40629
	],
	"./pl.json": [
		41019,
		41019
	],
	"./pt-br.json": [
		78394,
		78394
	],
	"./pt.json": [
		36851,
		36851
	],
	"./ru.json": [
		89002,
		89002
	],
	"./tr.json": [
		27653,
		27653
	],
	"./zh.json": [
		83905,
		83905
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 76986;
module.exports = webpackAsyncContext;